import { Injectable } from '@angular/core';
import jwt_decode from "jwt-decode";

import { Token } from '../models/token.model';

@Injectable({
    providedIn: 'root'
})
export class TokenService {

    private tokenName: string = "campus_token";

    constructor() { }

    public getToken(): string {
        return localStorage.getItem(this.tokenName);
    }

    public setToken(token: string): void {
        localStorage.setItem(this.tokenName, token);
    }

    public removeToken() {
        localStorage.removeItem(this.tokenName);
    }

    public isTokenExpired(token?: string): boolean {

        if(!token) token = this.getToken();
        if(!token) return true;

        const date = this.getTokenExpirationDate(token);
        if(date === undefined) return false;
        return !(date.valueOf() > new Date().valueOf());

    }

    private getTokenExpirationDate(token: string): Date {

        const decoded = jwt_decode<Token>(token);
        if (decoded.exp === undefined) return null;

        const date = new Date(0);
        date.setUTCSeconds(decoded.exp);
        return date;

    }

}
